import type { GtmReservationCompleteEvent, GtmFunnelEventBase } from './types'

export function pushGtmEvent(event: GtmReservationCompleteEvent): void
export function pushGtmEvent(event: GtmFunnelEventBase): void
export function pushGtmEvent(event: GtmFunnelEventBase): void {
  try {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(event)
  } catch {
    // GTM error should not block the main application flow
  }
}
